<template>
  <div
    class="row myrow content-mb-42 mrg-top-40"
    v-if="$parent.$parent.rerender"
  >
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_PRODUCT_REQ_719'
        )
      }"
    >
      <p class="content-s-2-label">
        <label
          >Продукция проекта (Требования к промышленной продукции, предъявляемые
          в целях ее отнесения к продукции, произведенной на территории
          Российской Федерации согласно Постановлению №719):</label
        >
      </p>
      <div class="info-holder-container">
        <div
          v-if="
            $parent.project &&
              $parent.project.UF_HELP.FIELDS.STEP2.UF_PRODUCT_REQ_719
          "
          class="info-holder-icon_ info-holder-icon_inp"
        ></div>
        <div
          v-if="
            $parent.project &&
              $parent.project.UF_HELP.FIELDS.STEP2.UF_PRODUCT_REQ_719
          "
          class="info-holder-content info-holder-content_inp"
        >
          <div class="info-holder-content__text">
            {{ $parent.project.UF_HELP.FIELDS.STEP2.UF_PRODUCT_REQ_719 }}
          </div>
        </div>
        <textarea
          v-on:keyup="
            $parent.$parent.removeError(
              'PROJECTS',
              'LOGIC',
              'UF_PRODUCT_REQ_719'
            )
          "
          class="i-main-style t-dop-style i-wid-50"
          style="height:114px;"
          v-model="$parent.project.UF_PRODUCT_REQ_719"
          :disabled="$parent.$parent.projectDisabled"
          placeholder=""
        />
      </div>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_PRODUCT_REQ_719"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_annotation"
};
</script>

<style scoped></style>
